import React from "react";
import gql from "graphql-tag";
import {
  EButtonIconBox,
  ELinkModalBuyButton,
} from "@organisms/linkModalComponents/BuyButton/BuyButtonEmotion";
import { LinkType } from "@types";
import { useStoreAppValue } from "@hooks";
import { RailsUrl, renderIf } from "@services";
import { Box, Image } from "@atoms";
import { InStoreModalQuery_Link_location } from "../../inStoreComponents/InStoreModal/__generated__/InStoreModalQuery";
import { BuyButtonFragment } from "./__generated__/BuyButtonFragment";

// == Types ================================================================

interface IProps {
  link: BuyButtonFragment;
  onLinkClick: () => void;
  tinyLinkKey?: string;
  campaignId?: string;
  fundraiserId?: string;
  linkLocation?: InStoreModalQuery_Link_location;
}

// == Constants ============================================================

const GIFTCARD_BUTTON_IMAGE =
  "https://d2wkegjj8g6j4.cloudfront.net/images/site/shop/link-modal-giftcard-v2.png";
const SHOP_BUTTON_IMAGE =
  "https://d2wkegjj8g6j4.cloudfront.net/images/site/shop/link-modal-shop.png";
const IN_STORE_BUTTON_IMAGE = "https://flipgive.imgix.net/images/site/shop/link-modal-in-store.png";

BuyButton.fragment = gql`
  fragment BuyButtonFragment on Link {
    id
    type
    defaultBrand {
      id
    }
  }
`;

// == Component ============================================================

// TODO: remove giftcard code here once checkout goes up

export default function BuyButton({
  link,
  campaignId,
  fundraiserId,
  onLinkClick,
  tinyLinkKey,
  linkLocation,
}: IProps) {
  const {
    currentUser,
    featureFlags: { newCheckout },
  } = useStoreAppValue();
  const isGiftcard = link.type === LinkType.GIFTCARDOFFER;
  if (isGiftcard && newCheckout) return null;

  const userNeedsSignUp = !currentUser && !campaignId && !fundraiserId;
  let href;
  let ctaText;
  if (userNeedsSignUp) {
    href = `${RailsUrl.createTeamUrl()}?s=${tinyLinkKey}`;
    ctaText = "Sign Up And Register Your Team To Shop";
  } else if (link.type === LinkType.EMPYR && currentUser) {
    href = RailsUrl.createInStoreUrl({
      campaignId,
      linkId: link.id,
      locationId: linkLocation.id,
      fundraiserId,
    });
    ctaText = "Shop In-Store";
  } else if (isGiftcard) {
    href = RailsUrl.createPurchaseUrl({ campaignId, linkId: link.id, fundraiserId });
    ctaText = "Buy Now";
  } else {
    href = RailsUrl.createShopUrl({ campaignId, linkId: link.id, fundraiserId });
    ctaText = "Shop Now";
  }

  return (
    <ELinkModalBuyButton
      as="a"
      href={href}
      target="_blank"
      userNeedsSignUp={userNeedsSignUp}
      onClick={() => currentUser && onLinkClick()}
    >
      {renderIf(!userNeedsSignUp)(
        <EButtonIconBox>
          <Box>
            <Image
              alt={isGiftcard ? "Giftcard" : link.type === LinkType.EMPYR ? "Empyr" : "Shop"}
              src={
                isGiftcard
                  ? GIFTCARD_BUTTON_IMAGE
                  : link.type === LinkType.EMPYR
                  ? IN_STORE_BUTTON_IMAGE
                  : SHOP_BUTTON_IMAGE
              }
            />
          </Box>
        </EButtonIconBox>
      )}
      {ctaText}
    </ELinkModalBuyButton>
  );
}

// == Styles ===============================================================
